export default "__VITE_ASSET__DYWTrvEs__"